<template>
  <div class="nlp__how-it-works-box">
    <h2>
      How It Works
    </h2>
    <div class="nlp__how-it-works-image">
      <NlpHowItWorksImageDesktop v-if="isNlpDesktop" />
      <NlpHowItWorksImageTablet v-else-if="isNlpTablet" />
      <NlpHowItWorksImageMobile v-else-if="isNlpMobile" />
    </div>
    <div class="nlp__button-box">
      <NlpButton
        primary
        text="Try Now"
        @button-click="$router.push({ name: 'source-of-funds' })"
      />
    </div>
  </div>
</template>

<script>
// Components
import NlpHowItWorksImageDesktop from '@/pages/landing-page/svg/NlpHowItWorksImageDesktop.vue'
import NlpHowItWorksImageTablet from '@/pages/landing-page/svg/NlpHowItWorksImageTablet.vue'
import NlpHowItWorksImageMobile from '@/pages/landing-page/svg/NlpHowItWorksImageMobile.vue'
import NlpButton from '@/pages/landing-page/ui-components/NlpButton.vue'

// Mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin.js'

export default {
  name: 'NlpHowItWorks',
  components: {
    NlpHowItWorksImageDesktop,
    NlpHowItWorksImageTablet,
    NlpHowItWorksImageMobile,
    NlpButton,
  },
  mixins: [deviceWidthMixin],
}
</script>

<style scoped>
.nlp__how-it-works-box h2 {
  margin-bottom: 60px;
}

.nlp__how-it-works-image svg {
  object-fit: contain;
  width: 100%;
  height: auto;
}
</style>